const translations = {
  "en": {
    "Current plan": "Current plan",
    "Get Complete Forever": "Get Complete Forever",
    "Start Your 7-Day Free Trial": "Start Your 7-Day Free Trial",
    "Start Your 7-Day Trial for $1.99": "Start Your 7-Day Trial for $1.99",
    "Subscribe": "Subscribe"
  },
  "zh-tw": {
    "Current plan": "目前計畫",
    "Get Complete Forever": "取得 Complete 永久版",
    "Start Your 7-Day Free Trial": "開始你的 7 天免費試用",
    "Start Your 7-Day Trial for $1.99": "開始你的7天試用，僅需1.99美元",
    "Subscribe": "訂閱"
  }
};

export default translations;
